module.exports = __webpack_public_path__ + "img/ad.4130c7bd.svg";